// extracted by mini-css-extract-plugin
export default {"customInput":"CustomInput_customInput__A-vu5","fontTypeLarge":"CustomInput_fontTypeLarge__k8o3h","fontTypeSmall":"CustomInput_fontTypeSmall__wdwCS"};